import i18n from "../../../i18n";

const getNumberLocale = () => (i18n.language === "pl" ? "pl-PL" : "en-US");

/**
 * Axis ticks, formatted for an axis rather than for a figure.
 *
 * Deliberately not `formatNumber`: that pads every value to two decimals, so a
 * money axis reads "200 000,00" and the trailing ",00" - identical on every
 * tick and carrying no information - widens the axis gutter enough to crowd or
 * clip the labels. Axis ticks land on round numbers anyway, so the decimals are
 * noise; the exact amount is still in the tooltip and in the table below.
 */
export const formatAxisNumber = (value: unknown): string => {
  const numValue = Number(value);
  if (!Number.isFinite(numValue)) return "";

  return new Intl.NumberFormat(getNumberLocale(), {
    maximumFractionDigits: 0,
  }).format(numValue);
};
